import { Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { MasterService } from './service';
import { MasterData } from '../generated/types';

@Injectable()
export class MasterResolver implements Resolve<MasterData> {

  constructor(private masterService: MasterService) {

  }

  resolve() {
    return this.masterService.master;
  }
}
